import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import * as React from "react";

interface OwnProps extends WidgetProps {}

type Props = OwnProps;

const OneTrustCookiesList: React.FC<Props> = () => {
    return <div id="ot-sdk-cookie-policy"></div>;
};

const definition: WidgetDefinition = {
    displayName: "OneTrust Cookies List",
    group: "Common",
    fieldDefinitions: [],
};

const widgetModule: WidgetModule = {
    component: OneTrustCookiesList,
    definition,
};

export default widgetModule;
